import omit from 'lodash/omit';
import { ContactRole, SearchProjectEntities } from 'UI/constants/entityTypes';

export const formatCandidateMatchMakingResponse = response => {
  const formattedData = response.data.matches.data.map(item => ({
    ...item,
    fullName: {
      id: item?.id,
      fullName: item?.name
    },
    industrySpecialty:
      item?.industry && item?.specialty ? `${item.industry}: ${item.specialty}` : null,
    location: item?.stateSlug && item?.city ? `${item.city}, ${item.stateSlug}` : null,
    score: {
      score: item?.score,
      label: item?.scoreLabel
    },
    status: {
      id: item?.statusId,
      title: item?.status
    },
    type: {
      id: item?.typeId,
      title: item?.type
    },
    company: {
      id: item?.companyId,
      name: item?.companyName
    }
  }));

  const formattedPaginationData = omit(response.data.matches, 'data');
  return {
    ...response,
    data: { ...response.data, ...formattedPaginationData, data: formattedData }
  };
};

export const formatJobOrderMatchMakingResponse = response => {
  const formattedData = response.data.matches.data.map(item => ({
    ...item,
    title: {
      id: item?.id,
      title: item?.title
    },
    industrySpecialty:
      item?.industry && item?.specialty ? `${item.industry}: ${item.specialty}` : null,
    location: item?.stateSlug && item?.city ? `${item.city}, ${item.stateSlug}` : null,
    score: {
      score: item?.score,
      label: item?.scoreLabel
    },
    status: {
      id: item?.statusId,
      title: item?.status
    },
    type: {
      id: item?.typeId,
      title: item?.type
    },
    company: {
      id: item?.companyId,
      name: item?.companyName
    }
  }));

  const formattedPaginationData = omit(response.data.matches, 'data');

  return {
    ...response,
    data: { ...response.data, ...formattedPaginationData, data: formattedData }
  };
};

export const formatContactMatchMakingResponse = response => {
  const defaultContactRole = {
    id: ContactRole.Name,
    role: SearchProjectEntities.Contact
  };

  const formattedData = response.data.matches.data.map(item => ({
    ...item,
    fullName: {
      id: item?.id,
      fullName: item?.name || item?.fullName,
      roleId: item?.roleId || defaultContactRole.id
    },
    companyType: {
      id: item?.companyTypeId,
      title: item?.companyType
    },
    companyName: {
      id: item?.companyId,
      name: item?.companyName
    },
    industrySpecialty:
      item?.industry && item?.specialty ? `${item.industry}: ${item.specialty}` : null,
    location: item?.stateSlug && item?.city ? `${item.city}, ${item.stateSlug}` : null,
    score: {
      score: item?.score,
      label: item?.scoreLabel
    },
    role: item?.role || defaultContactRole.role,
    roleId: item?.roleId || defaultContactRole.id
  }));

  const formattedPaginationData = omit(response.data.matches, 'data');

  return {
    ...response,
    data: { ...response.data, ...formattedPaginationData, data: formattedData }
  };
};

export const formatApplicantMatchMakingResponse = response => {
  const formattedData = response.data.matches.data.map(item => ({
    ...item,
    fullName: {
      id: item?.id,
      name: item?.name
    },
    score: {
      score: item?.score,
      label: item?.scoreLabel
    }
  }));

  const formattedPaginationData = omit(response.data.matches, 'data');
  return {
    ...response,
    data: { ...response.data, ...formattedPaginationData, data: formattedData }
  };
};
